import { useState } from "react";
import controlMap from "../assets/controlMap.png";
import stats from "../assets/stats.png";
import vectrMode from "../assets/vectrMode.png";
import library from "../assets/library.png";

const tabs = [
  {
    id: "map",
    label: "Strategic Control Map",
    image: controlMap,
    tag: "Reflect. Learn. Improve.",
    title: "Weekly Mirror keeps you accountable for your strategic progress",
    description:
      "Reflect, learn, and improve - with a complete view of how your time and effort translated into impact or did not",
    bullets: [
      "Track time spent across task categories",
      "See how much effort went into strategic vs operational work",
      "Identify patterns that hold you back/ push you ahead",
      "Ways to improve task level effort",
    ],
  },
  {
    id: "stats",
    label: "Stats",
    image: stats,
    tag: "Activity to Insight",
    title: "Statistics to provide real time measure of your strategic performance",
    description:
      "Work isn't just about completion - it's about importance, control, and impact. vectr42 shows how your tasks stack up, where your effort is going, and what needs to change.",
    bullets: [
      "See status across completed, in-progress, and committed work",
      "Understand personal progress, not just completion titles",
      "Know what's on the line before it becomes a problem",
      "Balance strategy vs execution, effort on high-impact work",
    ],
  },
  {
    id: "vectrmode",
    label: "Vectrmode",
    image: vectrMode,
    tag: "Intelligence in Actions",
    title: "vectrMode offers actions customised to priority and control levels of each task",
    description:
      "Structurally enhance tasks with a list of recommended actions that help execute with clarity.",
    bullets: [
      "Action prompts help you structure outcomes, clarify intent, and think strategically",
      "Every action is designed to move the needle - making it more strategically relevant and bringing control",
      "It tries to also reduce noise by helping you reprioritize your effort",
      "Giving you the option to create your own strategic key actions that define each task better",
    ],
  },
  {
    id: "library",
    label: "Library",
    image: library,
    tag: "Apply what works",
    title: "Leverage best practice Library to gain advantage",
    description:
      "The Best Practice Library brings proven ways of thinking and executing, so you are a step ahead in crafting stronger actions for your tasks.",
    bullets: [
      "Access curated best practices for each grid across strategic and control",
      "Added actions for all tasks under 'Get Things Moving' and 'Portfolio Management'",
      "Apply structured methods to reduce friction, align stakeholders, and drive outcomes",
      "Skip trial-and-error, adopt approaches that are already known to work",
    ],
  },
];

const KeyFeatures = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tab = tabs[activeTab];

  return (
    <section className="key-features">
      <div className="key-features-header">
        <p className="key-features-label">Built for intuitive use</p>
        <h2 className="key-features-title">vectr42 key features</h2>
      </div>

      <div className="key-features-card">
        <div className="key-features-grid">
          <div className="key-features-phone">
            <img src={tab.image} alt={tab.label} className="phone-mockup" />
          </div>

          <div className="key-features-tabs">
            {tabs.map((t, i) => (
              <button
                key={t.id}
                className={`key-tab ${i === activeTab ? "active" : ""}`}
                onClick={() => setActiveTab(i)}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className="key-features-text">
            <p className="key-features-tag">{tab.tag}</p>
            <h3 className="key-features-subtitle">{tab.title}</h3>
            <p className="key-features-desc">{tab.description}</p>
            <ul className="key-features-bullets">
              {tab.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
